# Records

Every record in the pair, matched across the two runs by the source profile's
identity key.

- **Status** is what happened to the record between runs: added, removed,
  changed, or unchanged.
- **Severity** is the quality engine's view of it, which is not the same thing.
  An unchanged record can still fail a rule; a changed one is often fine.

Filter by status, by the field that changed, and by the kind of change —
`emptied` is usually the one worth starting with, because a field that went
blank between runs is what recovery can act on.

Open a record to see both sides of every changed field, and the document
comparison where the export carries document payloads.
